import { faBell } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CriticalAlarmIcon } from 'components/icon/CriticalAlarmIcon';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';
import { AlertSeverity, type AlertSeverityType } from 'utils/alert_severity';

export function severityColor(severity: AlertSeverityType): string {
    switch (severity) {
        case AlertSeverity.CRITICAL:
            return tokens.asset.critical;
        case AlertSeverity.ALARM:
            return tokens.asset.alarm;
        case AlertSeverity.WARNING:
            return tokens.asset.warning;
        default:
            throw new Error(`severity out of range: ${severity}`);
    }
}

const AlertIcon = styled.span<{ $severity: AlertSeverityType }>`
    display: inline-flex;
    font-size: 1.2rem;
    color: ${(p) => severityColor(p.$severity)};
`;

export function SeverityAlertIcon({ severity }: { severity: AlertSeverityType }) {
    return (
        <AlertIcon $severity={severity}>
            {severity === AlertSeverity.CRITICAL ? (
                <CriticalAlarmIcon />
            ) : (
                <FontAwesomeIcon icon={faBell} />
            )}
        </AlertIcon>
    );
}
